/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { bem } from "../shared/BEM";

/**
 * Component props
 */
export interface IOutputGroupProps {
	children: any;
}

/**
 * Outptu group component
 *
 * @param props Component props
 */
export function OutputGroup(props: IOutputGroupProps) {

	const style = bem("output-group");

	return <div className={style.className()}>
		{props.children}
	</div>;

}
